import React, { Fragment, useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { useParams } from "react-router-dom";
import { Row, Col, Nav, Tab, Card, Dropdown } from "react-bootstrap";
import {
  FiUser,
  FiCalendar,
  FiEdit,
  FiMoreVertical,
  ThreeDotsVertical,
  FiChevronRight,
  FiHome,
} from "react-icons/fi";
import "../../assets/css/details.css";
import {
  getGroupDetails,
  getGroupUsersList,
  deleteGroup,
  deleteGroupUser,
  updateGroupStatus,
  updateGroup,
  getDefaultUserList,
} from "../../services/Users-services";
import { useSharedState, useGlobalState } from "../../services/hostelConst.js";
import { getOrganizationLevel } from "../../services/OrganisationServices/organizationLevel";
import {
  showErrorMessages,
  getDefaultColumns,
} from "../../services/utilityFunctions.js";
import MasterTable from "../../views/dashboard/widget/MasterTabel.js";
import MasterTable2 from "../../views/dashboard/widget/MasterTabe2";
import AddGroupUserForm from "../../components/FormComponents/AddGroupuser";
import { getLocalStorageData } from "../../services/axiosComponent";
import DetailsPageNavigation from "../../views/dashboard/widget/detailsPageNavigation";
import MasterActions from "../../views/dashboard/widget/MasterActions";
import { getMethods } from "../../services/utilityFunctions";
import AddGroupForm from "../../components/FormComponents/AddGroups";
import placeHolder from "../../assets/images/placeHolderProfile.jpg";
import { useSelector, useDispatch } from "react-redux";
import {
  closeModal,
  openModal,
  updateIds,
} from "../../services/redux/reducers/modalSlice";
const GroupDetailsPage = ({ navigate }) => {
  var navigate = navigate;
  const [sharedState, setSharedState] = useSharedState();
  var { id } = useParams();
  const modal = useSelector((state) => state.modal);
  const dispatch = useDispatch();

  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [methods, setMethods] = useState({});
  const [groupLevelList, setGroupLevelList] = useState([]);

  const getGroupLevelList = async () => {
    var res = await getOrganizationLevel({
      type: "GROUP",
      organizationId:
        getLocalStorageData("profileDetails")["_ORGANIZATION_"]["_ID"],
    });
    if (res.status === "success") {
      var list = [];
      res.data.map((item) => {
        list.push({ value: item._ID, label: item.NAME });
      });

      return list;
    } else {
      showErrorMessages({ data: res, navigate });
      return [];
    }
  };
  const userId = getLocalStorageData("profileDetails")._ID;
  const fetchDetails = async ({ id, isLoading = false }) => {
    if (isLoading) setLoading(true);
    console.log(modal, "modal in grp");
    var res = await getGroupLevelList();
    const response = await getGroupDetails(id);
    if (response.status === "success") {
      setGroupLevelList(res);
      setMethods(await getMethods("User Management", "Group Users"));
      setDetails(response.data);
      dispatch(
        openModal({
          data: response.data,
        })
      );
      dispatch(
        updateIds({
          groupId: id,
          groupAdminId: response.data["_GROUP ADMIN_"]["_ID"],
        })
      );
    } else {
      showErrorMessages({ data: response, navigate });
    }
    setLoading(false);
  };
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      dispatch(
        openModal({
          title: "Group",
          body: (
            <AddGroupForm
              navigate={navigate}
              refresh={() => {
                fetchDetails({ id, isLoading: false });
              }}
            />
          ),
        })
      );
    }
    fetchDetails({ id });
  }, []);

  return (
    <Fragment>
      {loading ? (
        <center>
          <div class="spinner-border text-primary" role="status">
     
          </div>
        </center>
      ) : (
        <Row className="mb-3">
          <Row className="mb-1  pb-0">
            <Col lg="12" className="mb-0 pb-0 ">
              <Card
                className="position-relative border-0  transition-all "
                style={{ borderRadius: "1rem", transition: "0.3s" }}
              >
                <Card.Body className="p-3 px-lg-4 py-lg-3">
                  <Row className="">
                    {/* Left Section */}

                    <Col className=" ">
                      <DetailsPageNavigation list={["Groups", "Details"]} />
                      <Col className="pe-0 me-0 d-flex align-items-center gap-4">
                        <div
                          className="position-relative rounded-3 overflow-hidden"
                          style={{
                            height: "17vh",
                            backgroundColor: "#f8f9fa",
                            border: "1px solid rgba(0,0,0,0.05)",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                          }}
                        >
                          <img
                            src={details?.IMAGE_URL || placeHolder}
                            alt={details["NAME"]}
                            className="w-100 h-100 object-fit-cover"
                            onError={(e) => {
                              e.target.src = placeHolder;
                            }}
                          />
                        </div>
                        <div className="">
                          <div className="d-flex align-items-start gap-2 mb-2">
                            <h3
                              className="mb-0 fw-bold fs-4 text-truncate"
                              style={{
                                background:
                                  "linear-gradient(45deg, #2b2b2b, #4a4a4a)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                              }}
                            >
                              {details?.NAME}
                            </h3>
                          </div>
                          <p
                            className="text-muted mb-2 fs-6"
                            style={{
                              lineHeight: 1.5,
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {details?.DESCRIPTION || "No description available"}
                          </p>
                        </div>
                      </Col>
                    </Col>

                    {/* Right Section */}
                    <Col lg="3" className="h-100">
                      <div
                        className="d-flex flex-column gap-1 justify-content-between "
                        style={{
                          gap: "clamp(0.5rem, 2vh, 1rem)",
                          minHeight: "17vh",
                          padding: "clamp(0.5rem, 2vh, 1.5rem) 0",
                        }}
                      >
                        <div className="d-flex align-items-center p-2 hover-bg-light rounded-2">
                          <div
                            className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                            style={{
                              width: "clamp(24px, 4vw, 32px)",
                              height: "clamp(24px, 4vw, 32px)",
                              flexShrink: 0,
                            }}
                          >
                            <FiUser className="text-primary fs-6" />
                          </div>
                          <div>
                            <div
                              className={`text-dark fw-medium`}
                              style={{ fontSize: "0.875rem" }}
                            >
                              {details["CREATED BY"]}
                            </div>

                            {/* <small className="text-muted">{subLabel}</small> */}
                          </div>
                        </div>

                        <div className="d-flex align-items-center p-2 hover-bg-light rounded-2">
                          <div
                            className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                            style={{
                              width: "clamp(24px, 4vw, 32px)",
                              height: "clamp(24px, 4vw, 32px)",
                              flexShrink: 0,
                            }}
                          >
                            <FiCalendar className="text-success fs-6" />
                          </div>
                          <div>
                            <div
                              className={`text-dark fw-medium`}
                              style={{ fontSize: "0.875rem" }}
                            >
                              {details["LAST MODIFIED"]}
                            </div>

                            {/* <small className="text-muted">{subLabel}</small> */}
                          </div>
                        </div>
                        <div className="d-flex align-items-center p-2 hover-bg-light rounded-2">
                          <div
                            className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                            style={{
                              width: "clamp(24px, 4vw, 32px)",
                              height: "clamp(24px, 4vw, 32px)",
                              flexShrink: 0,
                            }}
                          >
                            <FiEdit className="text-danger fs-6" />
                          </div>
                          <div>
                            <div
                              className={`text-dark fw-medium`}
                              style={{ fontSize: "0.875rem" }}
                            >
                              {details["MODIFIED BY"]}
                            </div>

                            {/* <small className="text-muted">{subLabel}</small> */}
                          </div>
                        </div>
                        {details["_IS ADMIN"] == "Y" && (
                          <div className="d-flex align-items-center p-2 hover-bg-light rounded-2">
                            <div
                              className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                              style={{
                                width: "clamp(24px, 4vw, 32px)",
                                height: "clamp(24px, 4vw, 32px)",
                                flexShrink: 0,
                              }}
                            >
                              <MasterActions
                                actions={{
                                  edit: details["_IS ADMIN"] == "Y",
                                  delete: userId == details["_GROUP OWNER"],
                                  status: userId == details["_GROUP OWNER"],
                                }}
                                methods={methods}
                                refresh={() =>
                                  fetchDetails({ id, isLoading: false })
                                }
                                deleteRow={deleteGroup}
                                updateStatus={updateGroupStatus}
                                updateRow={updateGroup}
                                isDetailsPage={true}
                                item={details}
                                AddForm={
                                  <AddGroupForm
                                    navigate={navigate}
                                    refresh={() =>
                                      fetchDetails({ id, isLoading: false })
                                    }
                                  />
                                }
                              />
                            </div>
                            <div
                              className="text-dark fw-medium"
                              style={{
                                fontSize: "clamp(0.75rem, 1.5vw, 0.875rem)",
                              }}
                            >
                              Show Options
                            </div>
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row className="mt-0">
            <Col lg="12">
              <MasterTable
                tab1={"User Management"}
                tab2={"Group Users"}
                actions={{
                  delete: true,
                }}
                deleteRow={deleteGroupUser}
                getTableData={getGroupUsersList}
                entityId={details["_ID"]}
                isGroupAdmin={details["_IS ADMIN"] == "Y" ? true : false}
                groupId={id}
                userId={getLocalStorageData("profileDetails")._ID}
                details={details}
                groupOwnerId={details["_GROUP OWNER"]}
                groupLevelList={groupLevelList}
                type={"GROUP"}
                AddForm={AddGroupUserForm}
                // updateStatus={updateGroupStatus}
              />
              {/* <MasterTable2
                deleteFun={deleteGroupUser}
                getList={getGroupUsersList}
                groupLevelList={groupLevelList}
                adminId={details["_GROUP ADMIN_"]["_ID"]}
                groupId={id}
                details={details}
                AddForm={AddGroupUserForm}
                refresh={() => fetchDetails({ id, isLoading: false })}
                actions={{
                  delete: true,
                }}
                userId={getLocalStorageData("profileDetails")._ID}
                tab1={"User Management"}
                tab2={"Group Users"}
                isAdmin={details["_IS ADMIN"] == "Y" ? true : false}
                title={"Group Users"}
                subTitle={"User"}
                type={"GROUP"}
              /> */}
            </Col>
          </Row>
        </Row>
      )}
    </Fragment>
  );
};

export default GroupDetailsPage;
